import { getPlanId } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/util/urls';

// eslint-disable-next-line jira/export/no-external-exports
export { persistReducer } from '@atlassian/jira-portfolio-3-portfolio/src/common/redux/persistence';

export const getPlanPrefixedKey = (key: string) => {
	const planId = getPlanId() || 'none';
	return `jpo-app-simple-plans-${planId}-${key}`;
};
